module.exports = __webpack_public_path__ + "static/media/18ECA9.b28771b6.jpg";